import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { keyBy } from '../../../../../../helpers/core';
import { formatPayload, getProp } from '../../../../../../helpers/formatProp';
import { t } from '../../../../../../i18n';

const initState = {
  editForm: null,
  loading: false,
  formInfo: null,
  apiValidationErrors: [],
  baseError: null,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'positions') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', {
        fieldName: t('dash.clients.components.accreditations.positions_label'),
      });
    }
  }

  return error;
}

function onLoadFormDataRequest(state) {
  return { ...state, loading: true };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { formInfo } = payload;

  formInfo.accreditations = formInfo.accreditations.map(item => ({
    ...item,
    disabled: item.already_applied,
  }));

  return {
    ...state,
    editForm: formatPayload(
      {
        accreditations: [{ id: null, positions: [], child_company_ids: [] }],
      },
      validate,
    ),
    loading: false,
    formInfo,
  };
}

function onCreateAccreditationRequest(state) {
  return { ...state };
}

function onCreateAccreditationSuccess(state, { payload }) {
  const { data } = payload;
  const { accreditation_id, ...otherProps } = data;

  return {
    ...state,
    accreditation: { ...otherProps, accreditation: accreditation_id },
    editForm: null,
  };
}

function onCreateAccreditationError(state, { payload }) {
  return { ...state, apiValidationErrors: payload, baseError: payload.base?.[0] };
}

function onChangeProperty(state, { payload }) {
  const { attr, value, silent } = payload;
  const { editForm } = state;

  if (Array.isArray(attr)) {
    if (attr.length > 2) {
      let data = null;
      const name = attr[attr.length - 1];
      for (let i = 0; i < attr.length - 1; i += 1) {
        data = (data || editForm)[attr[i]];
      }

      data[name] = silent ? value : getProp(attr, value, validate);
    } else if (attr.length === 2) {
      if (!editForm[attr[0]]) {
        editForm[attr[0]] = {};
      }
      editForm[attr[0]][attr[1]] = silent ? value : getProp(attr, value, validate);
    } else {
      editForm[attr[0]] = silent ? value : getProp(attr, value, validate);
    }
  } else {
    editForm[attr] = {
      value,
      error: validate(attr, value),
      name: attr,
      touched: true,
    };
  }

  return { ...state, editForm: { ...editForm } };
}

function onClearStore() {
  return { ...initState };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return { ...value, touched: true };
    },
  );

  return { ...state, editForm };
}

export default createReducer(initState, {
  [actions.LOAD_DATA_REQUEST]: onLoadFormDataRequest,
  [actions.LOAD_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.CREATE_DATA_SUCCESS]: onCreateAccreditationSuccess,
  [actions.CREATE_DATA_ERROR]: onCreateAccreditationError,
  [actions.CREATE_DATA_REQUEST]: onCreateAccreditationRequest,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.TOUCH]: onTouch,
});
